import { render, staticRenderFns } from "./hzbanner.vue?vue&type=template&id=6c0ed067&scoped=true"
import script from "./hzbanner.vue?vue&type=script&lang=js"
export * from "./hzbanner.vue?vue&type=script&lang=js"
import style0 from "./hzbanner.vue?vue&type=style&index=0&id=6c0ed067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ed067",
  null
  
)

export default component.exports